//import PlayTest from "../components/PlayTest.vue";
//import ActivityPlayDebug from "../components/ActivityPlayDebug.vue"; // unused, route disabled
//import PlayMoodle from "../components/PlayMoodle.vue";

function checkPermission(permission) {
  let permissions = JSON.parse(localStorage.getItem("user"));
  permissions = permissions.permissions;
  if (permissions) {
    for (let i = 0; i < permissions.length; i++) {
      if (permissions[i].name == permission) {
        return true;
      }
    }
  }
  return false;
}

export const routes = [
  {
    path: "/",
    alias: ["/home"],
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/test",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/Test.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  //All components and views wo header have to be loaded
  // without lazy loading ot avoid blinking(header appears and disappears)
  {
    path: "/documentation",
    name: "Documentation",
    component: () => import("../views/documentation/Documentation.vue"),
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
  },
  {
    path: "/goodPractices",
    name: "GoodPractices",
    component: () => import("../views/documentation/GoodPractices.vue"),
  },
  // {
  //   path: "/activityPlayDebug",
  //   name: "ActivityPlayDebug",
  //   component: ActivityPlayDebug,
  // },
  {
    //Use of ? to make parameters optional
    path: "/activity/:id/:repetitions?/:maxAttempts?/:solutionProvided?/:reviewProvided?/:versionNumber?",
    name: "Activity", //name is used to identify type of sequence (here it's a pseudo sequence)
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/SequenceView.vue"),
  },
  {
    //Use of ? to make parameters optional
    path: "/sequence/:id",
    name: "Sequence", //name is used to identify type of sequence (here it's a real sequence)
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/SequenceView.vue"),
    props: (route) => ({
      firstname: route.query.firstname,
      lastname: route.query.lastname,
    }),
  },

  {
    //Use of ? to make parameters optional
    path: "/sequence-skeleton/:id/:pseudoSequence?/:repetitions?/:maxAttempts?/:solutionProvided?/:reviewProvided?/:timer?",
    name: "SequenceSkeleton",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/SequenceViewSkeleton.vue"),
  },

  {
    //Use of ? to make parameters optional
    path: "/results",
    name: "Results",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/StudentsGrades.vue"),
  },

  /*
  {
    //Use of ? to make parameters optional
    path:
      "/playTest/:id/:nbActivities?/:feedbackProvided?/:solutionProvided?/:showGrades?/:timer?",
    name: "PlayTest",
    meta: { hideHeader: true, hideFooter: true },
    component: PlayTest,
  },*/

  {
    //Use of ? to make parameters optional
    path: "/error/:statusCodeHTTP?",
    name: "Error",
    component: () => import("../views/Error.vue"),
  },

  {
    //Use of ? to make parameters optional
    path: "/use/:id/:nbActivities?/:solutionProvided?/:reviewProvided?/:timer?",
    name: "Use",
    component: () => import("../views/Use.vue"),
  },
  /*
  {
    path: "/playMoodle/:id",
    name: "PlayMoodle",
    meta: { hideHeader: true, hideFooter: true },
    component: PlayMoodle,
  },*/
  {
    path: "/sso",
    name: "SSO",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/Sso.vue"),
  },
  //Lazy loaded components and views
  {
    path: "/myprofile",
    name: "MyProfile",
    // lazy-loaded
    component: () => import("../views/MyProfile.vue"),
  },
  {
    path: "/myactivities",
    name: "MyActivities",
    meta: { requiresAuth: true },
    // lazy-loaded
    component: () => import("../views/MyActivities.vue"),
  },
  {
    path: "/mysequences",
    name: "MySequences",
    meta: { requiresAuth: true },

    // lazy-loaded
    component: () => import("../views/MySequences.vue"),
  },
  {
    path: "/studenthome",
    name: "StudentHome",

    meta: {
      //hideFooter: true,
    },
    component: () => import("../views/StudentHome.vue"),
  },
  {
    path: "/sequencestats/:id",
    name: "SequenceStats",
    meta: { requiresAuth: true },

    // lazy-loaded
    component: () => import("../views/SequenceStats.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout.vue"),
  },
  {
    path: "/loginSimulateSSO",
    name: "LoginSimulateSSO",
    component: () => import("../views/LoginSimulateSSO.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/news",
    name: "News",
    component: () => import("../views/News.vue"),
  },
  {
    path: "/search/team/:id",
    name: "SearchPageTeam",
    meta: { requiresAuth: true },

    component: () => import("../views/SearchPage.vue"),
  },
  {
    // Vue Router 4 treats navigation between aliases of the same route as navigating
    // to "the same route" and silently no-ops (URL never updates), unlike Vue Router 3.
    // Separate named routes (still all rendering SearchPage.vue) keep navigation between
    // /search/certified, /search/all, etc. working; SearchPage.vue itself keeps parsing
    // $route.path the same way it always has.
    path: "/search",
    name: "SearchPage",
    component: () => import("../views/SearchPage.vue"),
  },
  {
    path: "/search/certified",
    name: "SearchPageCertified",
    component: () => import("../views/SearchPage.vue"),
  },
  {
    path: "/search/all",
    name: "SearchPageAll",
    component: () => import("../views/SearchPage.vue"),
  },
  {
    path: "/search/followed",
    name: "SearchPageFollowed",
    component: () => import("../views/SearchPage.vue"),
  },
  {
    path: "/search/favorites",
    name: "SearchPageFavorites",
    component: () => import("../views/SearchPage.vue"),
  },
  {
    path: "/collection/:name",
    name: "Collection",
    component: () => import("../views/Collection.vue"),
  },
  {
    path: "/collection/student/:name",
    name: "CollectionStudent",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/Collection.vue"),
  },
  {
    path: "/create",
    name: "Create",
    component: () => import("../views/Create.vue"),
  },
  {
    path: "/create/:id",
    name: "Create-import",
    component: () => import("../views/Create.vue"),
  },
  {
    path: "/activityEdit/:id",
    name: "activity-edit",
    meta: { requiresAuth: true },

    component: () => import("../components/ActivityEdit"),
  },
  {
    path: "/sequenceEdit/:id",
    name: "sequence-edit",
    meta: { requiresAuth: true },

    component: () => import("../components/SequenceEdit"),
  },
  {
    path: "/admin/user/:id",
    name: "user-details",
    component: () => import("../components/User"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/admin/tag/:id",
    name: "tag-details",
    component: () => import("../components/TagEdit"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/admin/sponsor/:id",
    name: "sponsor-details",
    component: () => import("../components/SponsorEdit"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },

  {
    path: "/verifyAccount/:activationKey",
    name: "user-verfication",
    component: () => import("../views/Verify.vue"),
  },
  {
    path: "/forgetPassword",
    name: "forget-password",
    component: () => import("../views/ForgetPassword.vue"),
  },
  {
    path: "/changePassword/:activationKey",
    name: "ChangePassword",
    component: () => import("../views/ChangePassword.vue"),
  },
  {
    path: "/welcome",
    name: "welcome-page",
    component: () => import("../views/Welcome.vue"),
  },
  {
    path: "/welcome/:code",
    name: "welcome-page-code",
    component: () => import("../views/Welcome.vue"),
  },
  {
    path: "/tutorials",
    name: "Tutorials",
    component: () => import("../views/documentation/Tutorials.vue"),
  },
  {
    path: "/adminSearchBlock",
    name: "adminSearchBlock",
    component: () => import("../views/AdminSearchBlock.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/adminActivities",
    name: "adminActivities",
    component: () => import("../views/AdminActivities.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/adminSequences",
    name: "adminSequences",
    component: () => import("../views/AdminSequences.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },

  {
    path: "/adminTags",
    name: "adminTags",
    component: () => import("../views/AdminTags.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/adminUsers",
    name: "adminUsers",
    component: () => import("../views/AdminUsers.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/adminSponsors",
    name: "adminSponsors",
    component: () => import("../views/AdminSponsors.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/requestBasicAccount",
    name: "RequestBasicAccount",
    component: () => import("../views/RequestBasicAccount.vue"),
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: () => import("../views/Pricing.vue"),
  },
  {
    path: "/sequencePreview",
    name: "sequencePreview",
    component: () => import("../views/SequencePreview.vue"),
  },
  {
    path: "/adminCertifiedStamp",
    name: "adminCertifiedStamp",
    component: () => import("../views/AdminCertifiedStamp"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/admin/certification/:id",
    name: "certification-edit",
    component: () => import("../components/CertifiedStampEdit"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/discourseSSO",
    name: "discourseSSO",
    component: () => import("../views/DiscourseSSO.vue"),
  },
  {
    path: "/userprofile/:id",
    name: "UserProfile",
    // lazy-loaded
    component: () => import("../views/UserProfile.vue"),
  },
  {
    path: "/adminComment",
    name: "adminComment",
    component: () => import("../views/AdminComments.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/joinTeam",
    name: "JoinTeam",
    // lazy-loaded
    component: () => import("../views/JoinTeam.vue"),
  },
  {
    path: "/joinTeam/:key",
    name: "JoinTeamWithKey",
    // lazy-loaded
    component: () => import("../views/JoinTeam.vue"),
  },
  {
    path: "/myTeams",
    name: "MyTeams",
    // lazy-loaded
    component: () => import("../views/MyTeams.vue"),
  },
  {
    path: "/adminRole",
    name: "AdminRole",
    // lazy-loaded
    component: () => import("../views/AdminRole.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/adminPermissions",
    name: "AdminPermissions",
    // lazy-loaded
    component: () => import("../views/AdminPermissions.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/adminEstablishment",
    name: "AdminEstablishment",
    // lazy-loaded
    component: () => import("../views/AdminEstablishment.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },

  {
    path: "/adminGar",
    name: "AdminGar",
    // lazy-loaded
    component: () => import("../views/AdminGar.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/adminAcademieStats",
    name: "AdminAcademieStats",
    // lazy-loaded
    component: () => import("../views/AdminAcademieStats.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },

  {
    path: "/admin/role/:id",
    name: "role-edit",
    component: () => import("../components/RoleEdit"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  /* A mettre avant le :id car meme mecanisme que coté route backend*/
  {
    path: "/admin/establishment/new",
    name: "establishment-create",
    component: () => import("../components/EstablishmentEdit"),
    props: { isNew: true }, // Pour ajouter un nouvel item
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/admin/establishment/:id",
    name: "establishment-edit",
    component: () => import("../components/EstablishmentEdit"),
    props: (route) => ({ id: route.params.id, isNew: false }), // Ajout de props
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },

  {
    path: "/myMembers",
    name: "MyMembers",
    // lazy-loaded
    component: () => import("../views/MyMembers.vue"),
  },
  {
    path: "/adminTeams",
    name: "AdminTeams",
    // lazy-loaded
    component: () => import("../views/AdminTeams.vue"),
    beforeEnter: (to, from, next) => {
      if (checkPermission("menu_admin")) {
        next();
      } else {
        next("/");
      }
    },
  },
  {
    path: "/cas/login",
    name: "CasLogin",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/CasLogin.vue"),
  },
  {
    path: "/cas/logout",
    name: "CasLogout",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/CasLogout.vue"),
  },
  {
    path: "/lti/home",
    name: "Lti Infos",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/lti/Infos.vue"),
  },
  {
    path: "/lti/deeplink",
    name: "Lti Resources",
    meta: {
      hideHeader: true,
      hideFooter: true,
    },
    component: () => import("../views/lti/Resources.vue"),
  },
  {
    path: "/verifyEmail",
    name: "VerifyEmail",
    component: () => import("../views/VerifyEmail.vue"),
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    // lazy-loaded
    component: () => import("../views/Subscriptions.vue"),
  },
  {
    path: "/legalNotices",
    name: "legalNotices",
    // lazy-loaded
    component: () => import("../views/legal/LegalNotices.vue"),
  },
  {
    path: "/dataProtection",
    name: "dataProtection",
    // lazy-loaded
    component: () => import("../views/legal/DataProtection.vue"),
  },
  {
    path: "/generalConditions",
    name: "generalConditions",
    // lazy-loaded
    component: () => import("../views/legal/GeneralConditions.vue"),
  },
  {
    path: "/opensource",
    name: "opensource",
    // lazy-loaded
    component: () => import("../views/legal/Opensource.vue"),
  },

  {
    path: "/:catchAll(.*)",
    redirect: {
      name: "Error",
      params: { statusCodeHTTP: "404" },
      query: {
        message: "Not Found",
      },
    }, // Redirige vers la route "Error" avec le code 404 par défaut
  },
];
